import { render, staticRenderFns } from "./AttributeTags.vue?vue&type=template&id=16eda48a&scoped=true&"
import script from "./AttributeTags.vue?vue&type=script&lang=js&"
export * from "./AttributeTags.vue?vue&type=script&lang=js&"
import style0 from "./AttributeTags.vue?vue&type=style&index=0&id=16eda48a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16eda48a",
  null
  
)

export default component.exports